import React from 'react'
import { useIntl } from 'react-intl'

import { DownOutlined } from '@ant-design/icons'
import { faPalette } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown, Button, Menu } from 'antd'
import PropTypes from 'prop-types'

const DesktopView = ({ theme, toggleTheme }) => {
  const intl = useIntl()

  const handleClick = ({ key }) => {
    toggleTheme(key)
  }

  const menu = (
    <Menu
      selectable
      selectedKeys={[theme]}
      onClick={handleClick}
      items={[
        {
          key: 'light',
          label: intl.formatMessage({
            id: 'global.labels.lightTheme',
          }),
        },
        {
          key: 'dark',
          label: intl.formatMessage({
            id: 'global.labels.darkTheme',
          }),
        },
        {
          key: 'auto',
          label: intl.formatMessage({
            id: 'global.labels.autoTheme',
          }),
        },
      ]}
    />
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <Button
        block
        type="text"
        icon={
          <FontAwesomeIcon icon={faPalette} style={{ marginRight: '6px' }} />
        }
        style={{
          width: '100%',
          textAlign: 'left',
          margin: 0,
          paddingLeft: 4,
          fontSize: 14,
        }}
        data-testid="themeswitchericon"
      >
        {intl.formatMessage({
          id: 'global.labels.theme',
        })}
        <span
          style={{
            float: 'right',
          }}
        >
          <DownOutlined style={{ fontSize: 10 }} />
        </span>
      </Button>
    </Dropdown>
  )
}

DesktopView.propTypes = {
  theme: PropTypes.string.isRequired,
  toggleTheme: PropTypes.func.isRequired,
}

export default DesktopView
